import { render, staticRenderFns } from "./AccountEudrTab.vue?vue&type=template&id=3ef79244&scoped=true&"
import script from "./AccountEudrTab.vue?vue&type=script&lang=js&"
export * from "./AccountEudrTab.vue?vue&type=script&lang=js&"
import style0 from "./AccountEudrTab.vue?vue&type=style&index=0&id=3ef79244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef79244",
  null
  
)

export default component.exports